import { render, staticRenderFns } from "./paymentIDEmpty.vue?vue&type=template&id=3d76ea24&"
import script from "./paymentIDEmpty.vue?vue&type=script&lang=js&"
export * from "./paymentIDEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports